export const styles = () => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    // This styles for accessibility
    '& label': {
      position: 'relative',
    },
    '& input': {
      position: 'absolute',
      width: 34,
      height: 34,
      zIndex: -1,
      left: 0,
    },
  },
  inputLabel: {
    position: 'relative',
    zIndex: 2,
    width: 34,
    height: 34,
    border: '1px solid #5A98F7',
    lineHeight: '32px',
    boxSizing: 'border-box',
    color: '#5A98F7',
    borderRadius: '50%',
    cursor: 'pointer',
    background: '#F7FAFF',
    transition: 'background ease-out .2s',

    '&:hover': {
      color: '#5A98F7',
      background: 'rgba(90, 152, 247, 0.1)',
    },
  },
  activeInputLabel: {
    background: '#5A98F7',
    color: '#ffffff',
  },
  isError: {
    border: '1px solid red',
  },
})
